import { createContext, useContext } from 'react';

import { RoomStatus, VideoSource } from '@features/video/types';

export type VideoStreamContextValue = {
  // участнику нужен видеоконтроль: включен в настройках, время пришло, он не сеансер
  visible: boolean;
  source: VideoSource;
  // состояние комнаты, когда снимает это устройство
  status?: RoomStatus;
  // связь с комнатой потеряна
  error: boolean;
  // микрофон или камера основной камеры с этого устройства выключены в эфире: игроком или судьей
  micOff: boolean;
  camOff: boolean;
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
};

export const VideoStreamContext = createContext<VideoStreamContextValue | null>(null);

// null вне турнирных страниц: виджеты игры живут и без видеоконтроля
export function useVideoStreamCtx(): VideoStreamContextValue | null {
  return useContext(VideoStreamContext);
}
